import { Inject, Injectable } from '@angular/core';
import { BullhornNamespace, normaliseBullhornEntityType, SalesforceNamespace } from 'datasource-service-lib';
import { EntityControllerService } from 'entity-picker-lib';
import { RUNTIME_ENVIRONMENT } from 'environments-lib';
import { IEntity, IRuntimeEnvironment } from 'interfaces-lib';
import { SessionInfoStorage } from 'storage-service-lib';
import { TemplateLaunchIntentService } from './template-launch-intent.service';

/**
 * A factory function approach rather than another IPostLoginActionService that is supplied by the ServiceProviderService.
 * Maybe the service approach makes more sense?
 */

@Injectable({ providedIn: 'root' })
export class PostLoginActionService {
  constructor(
    private entityControllerService: EntityControllerService,
    @Inject(RUNTIME_ENVIRONMENT) protected runtimeEnvironment: IRuntimeEnvironment | undefined,
    private sessionInfoStorage: SessionInfoStorage,
    private templateLaunchIntentService: TemplateLaunchIntentService
  ) {}

  execute(namespace: string): void {
    const urlString = this.runtimeEnvironment?.origin?.url ?? this.sessionInfoStorage.get()?.signInUrl;
    if (!urlString) {
      return;
    }
    const url = new URL(urlString);
    if (namespace === BullhornNamespace.name) {
      this.bullhornAction(url);
    }
    if (namespace === SalesforceNamespace.name) {
      this.salesforceAction(url);
    }
  }

  //region Bullhorn
  private bullhornAction(url: URL): void {
    const entityId = url.searchParams.get('EntityID');
    const entityType = normaliseBullhornEntityType(url.searchParams.get('EntityType') as string);
    const templateId = url.searchParams.get('templateId');

    if (templateId) {
      this.templateLaunchIntentService.set(templateId);
    }

    if (entityId && entityType) {
      this.entityControllerService.entitySelected({
        id: entityId,
        type: entityType,
      } as IEntity);
    }
  }
  //endregion

  // salesforce region
  private salesforceAction(url: URL): void {
    const entityId = url.searchParams.get('EntityID'); // configured into the visual force page
    const entityType = url.searchParams.get('EntityType'); // configured into the visual force page

    if (entityId && entityType) {
      this.entityControllerService.entitySelected({
        id: entityId,
        type: entityType,
      } as any);
    }
  }
  // endregion
}
